import { jsx as _jsx } from "react/jsx-runtime";
// frontend/src/components/SkillsBoard/SlackChannelPicker.tsx
// Autocomplete has no @weave-mui equivalent — stay on @mui, matching SkillFormModal's existing
// precedent for Dialog/InputLabel/FormControlLabel.
import { Autocomplete } from '@mui/material';
import { TextField } from '@weave-mui/material';
import { useSlackChannels } from '../../api/hooks';
export const MAX_CHANNEL_IDS = 20;
/** Multi-value Slack channel picker shared by SkillFormModal (create) and SkillSidebar (edit) —
 * both need identical dedup/cap/freeSolo behavior, so this is a single source of truth rather
 * than two independently-drifting copies. Lists channels the bot has actually joined
 * (GET /v1/slack/channels via useSlackChannels) and falls back to free-typed entry for a
 * channel the bot hasn't joined yet. Each add/remove is its own committed onChange call — the
 * caller can treat it as an immediate edit (no separate blur step needed, unlike a free-text
 * field where every keystroke would otherwise trigger a save). */
export default function SlackChannelPicker({ value, onChange }) {
    const { data, isLoading } = useSlackChannels();
    const channels = data?.results ?? [];
    const nameById = new Map(channels.map((c) => [c.channelId, c.name]));
    const atCap = value.length >= MAX_CHANNEL_IDS;
    const label = (id) => (nameById.has(id) ? `${nameById.get(id)} (${id})` : id);
    return (_jsx(Autocomplete, { multiple: true, freeSolo: true, size: "small", loading: isLoading, options: channels.map((c) => c.channelId), getOptionLabel: label, filterOptions: (options) => (atCap ? [] : options), value: value, onChange: (_e, newValue) => {
            const deduped = Array.from(new Set(newValue.map((v) => v.trim()).filter(Boolean)));
            onChange(deduped.slice(0, MAX_CHANNEL_IDS));
        }, renderInput: (params) => (_jsx(TextField, { ...params, label: "Slack channels", helperText: atCap
                ? `Maximum ${MAX_CHANNEL_IDS} channels`
                : 'Pick a bot-joined channel, or type a channel ID and press Enter for one not yet joined' })) }));
}
